<template>
  <div class="showDataTemplateModule">
    <secondTemplateVue v-if="level != 2"></secondTemplateVue>
    <!-- <showDataLevle v-if="level != 2"></showDataLevle> -->
    <firstTemplateVue v-else></firstTemplateVue>
  </div>
</template>

<script>
import firstTemplateVue from './module/firstTemplate.vue';
import secondTemplateVue from './module/secondTemplate.vue';
import showDataLevle from './showDataLevle.vue';
export default {
  data() {
    return {
      level: JSON.parse(localStorage.info).provincialAndMunicipalLevel,
    }
  },
  components: {
    firstTemplateVue,
    secondTemplateVue,
    showDataLevle,
  },
  mounted() {
    console.log(55555555)
    console.log(this.level, 55555)
  },
}
</script>

<style scoped>
.showDataTemplateModule {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/showData.vue